module.exports = __webpack_public_path__ + "img/SwissTrust7.c2f4bcf1.png";